import { EnumChip, registerEnumSet } from '@if/mui'
import { ESystemMatchingResult, getESystemMatchingResultList } from '@src/types/interac'
import { CircleCheck, CircleHelp, Clock, SearchX, TriangleAlert } from 'lucide-react'

registerEnumSet(ESystemMatchingResult, {
  [ESystemMatchingResult.Sure]: { color: 'success', icon: CircleCheck, labelKey: 'interacWire.matchResult.sure' },
  [ESystemMatchingResult.Potential]: {
    color: 'warning',
    icon: CircleHelp,
    labelKey: 'interacWire.matchResult.potential',
  },
  [ESystemMatchingResult.None]: { color: 'info', icon: SearchX, labelKey: 'interacWire.matchResult.none' },
  [ESystemMatchingResult.Error]: { color: 'error', icon: TriangleAlert, labelKey: 'interacWire.matchResult.error' },
  [ESystemMatchingResult.Unprocessed]: {
    color: 'sky',
    icon: Clock,
    labelKey: 'interacWire.matchResult.unprocessed',
  },
})

export const toSystemMatchingResult = (value: string | null): ESystemMatchingResult | null =>
  getESystemMatchingResultList().find((result) => result === value) ?? null

interface InteracMatchResultChipProps {
  systemMatchingResult: string | null
  size?: 'small' | 'medium'
}

const InteracMatchResultChip = ({ systemMatchingResult, size = 'small' }: InteracMatchResultChipProps) => {
  const value = toSystemMatchingResult(systemMatchingResult)
  if (!value) return null
  return <EnumChip set={ESystemMatchingResult} value={value} size={size} />
}

export default InteracMatchResultChip
